import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import deleteImage from "../assets/img/delete.png";

const DeleteConfirmationModal = ({ isOpen, toggle, onConfirm, itemName, isLoading }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Confirm Delete</ModalHeader>
      <ModalBody>
        <>
          <div className="text-center">
            <img src={deleteImage} alt="" style={{ width: "60px" }} />
            <p className="mt-3">Do you want to delete this {itemName}?</p>
            {itemName === 'company' && (
              <div className="alert alert-warning mt-3" role="alert">
                <strong>Warning:</strong> This action will permanently delete the data from all related sections including Oil, Users, and Company Masters. This will permanently delete the items.
              </div>
            )}
          </div>
        </>
      </ModalBody>
      <ModalFooter>
        <Button className="btn-primary" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? "Loading..." : "Delete"}
        </Button>{" "}
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteConfirmationModal;
